import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'iot-platform-ui-loader',
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  display = input(false);
}
